export const environment = {
  production: true,
  buildId: '4184131063624931',
  configFile: 'config.json',
};
